import React from 'react';
import { observer } from 'mobx-react';

import {
    StyledDefaultKitItemWrapper,
    StyledDefaultKitDescription,
    StyledDefaultKitImageWrapper,
    StyledDefaultKitProductSub
} from './DefaultKitItemStyles';

import { IKitItem } from '~api/KitsAPI/utils/IKits';
import { classes } from '~utils/ClassNames';
import { ShadeSize } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/CartItemDescription/ShadeSize/ShadeSize';

interface IDefaultKitItem {
    kitItem: IKitItem;
}

const kitItemsName = 'cart-kits';
export const wrapperClass = classes(`${kitItemsName}__item-wrapper`);
export const imageClass = classes(`${kitItemsName}__item-image`);
export const descriptionClass = classes(`${kitItemsName}__item-description`);
export const nameClass = classes(`${kitItemsName}__item-name`);
export const shadeSizeClass = classes(`${kitItemsName}__shade-size`);
export const shadeClass = classes(`${kitItemsName}__shade`);
export const sizeClass = classes(`${kitItemsName}__size`);

const DefaultKitItem = observer(({ kitItem }: IDefaultKitItem) => {
    const { name, shade, size, image, shadeCode } = kitItem;
    const thumb = Array.isArray(image) ? image[0] : image;

    return (
        <StyledDefaultKitItemWrapper className={wrapperClass}>
            <StyledDefaultKitImageWrapper className={imageClass} src={thumb} alt="" />
            <StyledDefaultKitDescription className={descriptionClass}>
                <StyledDefaultKitProductSub className={nameClass}>
                    {name}
                </StyledDefaultKitProductSub>
                <ShadeSize shade={shade} shadeCode={shadeCode} size={size} />
            </StyledDefaultKitDescription>
        </StyledDefaultKitItemWrapper>
    );
});

export default DefaultKitItem;
